/**
 * Wait for next tick
 * It is necessary to call requestAnimationFrame twice to ensure we are at the next repaint
 * https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
 *
 * @return Promise<void>
 */
const nextTick = () => new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => {
        resolve();
    }));
});

export { nextTick as n };
